// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vV4d","type":"styles_type__2MMDF","choices":"styles_choices__3fLQA"};